// What a person typed into a work item's rich-text field, comment box or
// reply box and has not saved yet — kept as Jira keeps it: leave the box
// (another field, another tab, another work item, a refresh) and the text
// is still there when you open it again; the field says "Unsaved changes"
// meanwhile. Save or Cancel ends the draft.
//
// Kept in this browser only, per person, per work item, per box (a "slot":
// field:<field id>, comment, reply:<thread root id>) — nothing is sent
// anywhere until Save. Storage that is blocked or holds something else
// reads as no draft; a write that does not fit is dropped quietly.
//
//   readDraft(accountId, issueKey, slot)        → { doc, internal? } | null
//   writeDraft(accountId, issueKey, slot, value)
//   clearDraft(accountId, issueKey, slot)
//   hasDraft(accountId, issueKey, slot)         → boolean (no parsing)

const STORAGE_PREFIX = 'zebra_draft';

export function draftKey(accountId, issueKey, slot) {
  return `${STORAGE_PREFIX}:${accountId || 'anon'}:${issueKey}:${slot}`;
}

export function readDraft(accountId, issueKey, slot, storage = globalThis.localStorage) {
  if (!issueKey) return null;
  try {
    const v = JSON.parse(storage.getItem(draftKey(accountId, issueKey, slot)) || 'null');
    return v && typeof v === 'object' && v.doc && typeof v.doc === 'object' ? v : null;
  } catch {
    return null;
  }
}

export function writeDraft(accountId, issueKey, slot, value, storage = globalThis.localStorage) {
  if (!issueKey || !value?.doc) return;
  try { storage.setItem(draftKey(accountId, issueKey, slot), JSON.stringify(value)); } catch { /* full or blocked */ }
}

export function clearDraft(accountId, issueKey, slot, storage = globalThis.localStorage) {
  if (!issueKey) return;
  try { storage.removeItem(draftKey(accountId, issueKey, slot)); } catch { /* blocked */ }
}

export function hasDraft(accountId, issueKey, slot, storage = globalThis.localStorage) {
  if (!issueKey) return false;
  try { return storage.getItem(draftKey(accountId, issueKey, slot)) != null; } catch { return false; }
}
